import { createContext, PropsWithChildren, useContext } from 'react';

export type GroupAttributeLabelContextValue = string | undefined;

const GroupAttributeLabelContext = createContext<GroupAttributeLabelContextValue>(undefined);

export function GroupAttributeLabelContextProvider({
    value,
    children,
}: PropsWithChildren<{ value?: GroupAttributeLabelContextValue }>) {
    return (
        <GroupAttributeLabelContext.Provider value={value}>
            {children}
        </GroupAttributeLabelContext.Provider>
    );
}

export function useGroupAttributeLabelContext() {
    return useContext(GroupAttributeLabelContext);
}